import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';

export const Footer: React.FC = () => {
  const Logo = require('../../../assets/images/logo_white.png');
  const currentYear = new Date().getFullYear();

  const ButtonMailto = ({ mailto, label }: { mailto: string; label: string }) => (
    <Link
      to="#"
      onClick={(e) => {
        e.preventDefault();
        window.location.href = mailto;
      }}
    >
      <p className="text-[#00D4FF] hover:text-white transition-colors duration-300 break-all">
        {label}
      </p>
    </Link>
  );

  return (
    <footer
      className="relative overflow-hidden text-white"
      style={{
        background: 'linear-gradient(to bottom, #041421 0%, #03010E 60%, #020812 100%)',
      }}
    >
      {/* 🌌 Cyan top glow line */}
      <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-[#00D4FF]/60 to-transparent blur-[1px]" />

      {/* 🔹 Main content */}
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center md:items-start py-12 px-6 md:px-12 gap-10 relative z-10 text-center md:text-left">
        {/* 🔹 Logo */}
        <div className="flex flex-col items-center md:items-start">
          <img
            src={Logo}
            alt="KI Consulting Logo"
            className="w-28 md:w-32 opacity-90 hover:opacity-100 transition-opacity duration-300 mb-4 md:mb-0"
          />
        </div>

        {/* 🔹 Support */}
        <div className="flex flex-col items-center md:items-start">
          <h2 className="font-semibold text-lg mb-2 text-white">Support</h2>
          <ButtonMailto mailto="mailto:info@kir-int-consult.com" label="info@kir-int-consult.com" />
        </div>

        {/* 🔹 Social Media */}
        <div className="flex flex-col items-center md:items-start">
          <h2 className="font-semibold text-lg mb-2 text-white">Social Media</h2>
          <ul className="flex space-x- pl-0">
            <li>
              <a
                href="https://www.linkedin.com/company/kir-int-consulting/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="hover:text-[#00D4FF] transition-transform duration-300 hover:scale-110"
              >
                <Linkedin size={26} strokeWidth={1.5} />
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* 🔹 Divider */}
      <div className="border-t border-[#00D4FF]/10 mt-2" />

      {/* 🔹 Bottom text */}
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center text-center md:text-left py-6 px-6 md:px-12 text-xs md:text-sm text-gray-300 gap-2 md:gap-0">
        <p>© COPYRIGHT {currentYear}. ALL RIGHTS RESERVED</p>
        <p>
          WEBSITE DESIGN BY{' '}
          <span className="text-[#00D4FF] font-semibold hover:underline cursor-pointer">
            Xencode
          </span>
        </p>
      </div>

      {/* ✨ Ambient glow background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_150%,rgba(0,212,255,0.15),transparent_80%)] pointer-events-none" />
    </footer>
  );
};

export default Footer;
